// =============================================================================
// FAQ accordion — toggle aria-expanded on .faq-item__summary buttons.
// Animation is CSS-only (grid-template-rows: 0fr → 1fr on .faq-item__answer).
// =============================================================================
(function ($) {
    'use strict';

    $(document).on('click', '.faq-item__summary', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
})(jQuery);
